__turbopack_context__.v({
  "checkbox": "ClkIJa_checkbox",
  "checkboxDone": "ClkIJa_checkboxDone",
  "dayBody": "ClkIJa_dayBody",
  "dayFigure": "ClkIJa_dayFigure",
  "dayFill": "ClkIJa_dayFill",
  "dayHead": "ClkIJa_dayHead",
  "dayPlanned": "ClkIJa_dayPlanned",
  "dayTrack": "ClkIJa_dayTrack",
  "grid": "ClkIJa_grid",
  "leadDays": "ClkIJa_leadDays",
  "plot": "ClkIJa_plot",
  "root": "ClkIJa_root",
  "taskClient": "ClkIJa_taskClient",
  "taskDone": "ClkIJa_taskDone",
  "trendArea": "ClkIJa_trendArea",
  "trendDone": "ClkIJa_trendDone",
  "trendMarker": "ClkIJa_trendMarker",
  "trendPlanned": "ClkIJa_trendPlanned",
  "trendSvg": "ClkIJa_trendSvg",
  "trendTip": "ClkIJa_trendTip",
  "trendWrap": "ClkIJa_trendWrap",
  "widget": "ClkIJa_widget",
  "widgetVisible": "ClkIJa_widgetVisible",
});
